// extracted by mini-css-extract-plugin
module.exports = {"container":"odUZg","news":"_3uLMu","section":"_1q1Yg","results":"_3bIlY","content":"_18Hit","isCup":"_35pC_","aside":"_24JKT","disclaimer":"_9CCC9"};